import { Link } from 'react-router-dom'
import { useT } from '../lib/i18n'
import styles from './NotLetIn.module.css'

/**
 * THE LIMIT, STATED — for a pack with no chooser to say it on (2026-08-29).
 *
 * ⚠ THIS REPLACES A SILENT REDIRECT, and the redirect is what three separate bug reports were
 * actually about. A doorless pack — every CHATS conversation — used to answer an unapproved reader
 * with `<Navigate to="/" />`: the shelf, no words, no reason. The founder's testers described it as
 * *"you click it and get routed to the front page"*, which is precisely what it looked like from
 * the outside and gave nobody anything to act on.
 *
 * A pack WITH doors never had this problem: `DoorChooser` renders every door inert and says the
 * limit once underneath. So the same account state produced a courteous explanation on one pack and
 * an unexplained bounce on another, and the difference was nothing the reader could see. This is
 * that missing sentence.
 *
 * ⚠ IT IS A STATEMENT, NOT AN APPARATUS. No sign-up prompt, no queue position, no progress toward
 * being let in — the reader is not being sold anything here and there is nothing for them to do. It
 * says what is true, keeps the way back, and stops. The attention covenant is served by having
 * nothing on this screen worth staying for.
 *
 * ⚠ COPY IS PLACEHOLDER, in the register `DoorChooser`'s locked line already uses ("you can look
 * around. going down opens when you are let in.") — that one names going DOWN a mountain, which is
 * meaningless for a conversation, so this needs its own. The founder writes the real thing. `is` is
 * his native gate; `es`/`pl`/`no` are the builder's and unreviewed.
 */
export default function NotLetIn({ title }: { title: string }) {
  const t = useT()

  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.line}>{t('gate.notYet')}</p>
        <Link to="/" className={styles.back}>
          ‹ BACK
        </Link>
      </div>
    </div>
  )
}
